import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "w-100 p-5" };
const _hoisted_2 = { class: "table" };
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "d-flex flex-wrap align-items-center" };
const _hoisted_5 = ["title"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        records: Object
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("table", _hoisted_2, [
                    _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Bild"),
                            _createElementVNode("th", null, "Flasche"),
                            _createElementVNode("th", null, "Farb Schema"),
                            _createElementVNode("th", null, "Farben"),
                            _createElementVNode("th", null, "Drucktyp"),
                            _createElementVNode("th", null, "Komplett-Design?"),
                            _createElementVNode("th", null, "Thema"),
                            _createElementVNode("th", null, "Design-Typ"),
                            _createElementVNode("th", null, "Branche"),
                            _createElementVNode("th", null, "Nutzung"),
                            _createElementVNode("th", null, "AI-Model"),
                            _createElementVNode("th", null, "Eingabe-Token"),
                            _createElementVNode("th", null, "Ausgabe-Token"),
                            _createElementVNode("th", null, "Erstellungszeit (s)")
                        ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.records, (record) => {
                            return (_openBlock(), _createElementBlock("tr", {
                                key: record.id
                            }, [
                                _createElementVNode("td", null, [
                                    _createElementVNode("img", {
                                        src: _ctx.route('configurator.imageUrlLoader.gptTestImage', record.id),
                                        alt: "Generated Image",
                                        style: { "width": "300px", "height": "auto" },
                                        class: "border border-dark"
                                    }, null, 8, _hoisted_3)
                                ]),
                                _createElementVNode("td", null, _toDisplayString(record.bottle), 1),
                                _createElementVNode("td", null, _toDisplayString(record.color_scheme), 1),
                                _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((record.colors || '').split(',').map(s => s.trim()).filter(Boolean), (color, idx) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: idx,
                                                title: color,
                                                style: _normalizeStyle({ background: color, width: '28px', height: '18px', border: '1px solid #000', marginRight: '6px', marginBottom: '6px' })
                                            }, null, 12, _hoisted_5));
                                        }), 128))
                                    ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(record.print_type), 1),
                                _createElementVNode("td", null, _toDisplayString(record.full_design), 1),
                                _createElementVNode("td", null, _toDisplayString(record.topic), 1),
                                _createElementVNode("td", null, _toDisplayString(record.design_type), 1),
                                _createElementVNode("td", null, _toDisplayString(record.industry_sector), 1),
                                _createElementVNode("td", null, _toDisplayString(record.usage), 1),
                                _createElementVNode("td", null, _toDisplayString(record.ai_model), 1),
                                _createElementVNode("td", null, _toDisplayString(record.input_token), 1),
                                _createElementVNode("td", null, _toDisplayString(record.output_token), 1),
                                _createElementVNode("td", null, _toDisplayString(record.creation_time), 1)
                            ]));
                        }), 128))
                    ])
                ])
            ]));
        };
    }
});
